if (window.top.location.origin !== window.self.location.origin) {
  window.parent.location = window.self.location
}
